<template>
  <base-property-icon-item :label="label">
    <template v-slot:icon>
      <bath-icon></bath-icon>
    </template>
  </base-property-icon-item>
</template>
<script>
import BathIcon from '../Icons/BathIcon.vue';
import BasePropertyIconItem from './BasePropertyIconItem.vue';
export default {
  props: ['label'],
  components: {
    BasePropertyIconItem,
    BathIcon
  },
};
</script>
